import { createSlice } from '@reduxjs/toolkit';
import {
  byIdReducerFn,
  createPaginationSlice,
  defaultInitialState,
} from './common.reducer';

/**
 * @public
 * @name materialSlice
 * @description Declares a slice for redux store state.
 */
export const materialSlice = createSlice({
  name: 'materials',
  initialState: defaultInitialState,
  reducers: {
    clearMaterials: () => ({ ...defaultInitialState }),
    addMaterials: (state, action) => ({
      ...state,
      byId: {
        ...state.byId,
        ...action.payload.reduce(byIdReducerFn('materialID'), {}),
      },
    }),
  },
});

/**
 * @private
 */
const materialUiInitialState = {
  searchTerm: '',
};
/**
 * @public
 * @name materialUiSlice
 * @description Declares a slice for redux store state.
 */
export const materialUiSlice = createSlice({
  name: 'materials',
  initialState: materialUiInitialState,
  reducers: {
    searchMaterialByName: (state, action) => ({
      ...state,
      searchTerm: action.payload,
    }),
    clearMaterialUiState: () => ({ ...materialUiInitialState }),
  },
});

/**
 * @private
 * @name materialPaginationSlice
 * @description Declares a pagination slice for redux store state to cache component ui state.
 */
export const materialPaginationSlice = createPaginationSlice(materialSlice.name);

/**
 * @public
 * @name materialActions
 * @description Provides actions for materials.
 */
export const materialActions = materialSlice.actions;

/**
 * @public
 * @name materialUiActions
 * @description Provides actions for material.
 */
export const materialUiActions = materialUiSlice.actions;

/**
 * @name materialPagingActions
 * @description Provides paging actions for materials.
 */
export const materialPagingActions = materialPaginationSlice.actions;
